import React, { useEffect, useState, useRef } from 'react';
import loadingSvg from '../../assets/bounceLoad.svg';
import config from '../../config/config';
import { format } from 'date-fns';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function PaymentReceipt() {
  const { API_BASE_URL } = config;
  const payment_id = sessionStorage.getItem('paymentId');

  const [TransictionDetails, setTransictionDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const receiptRef = useRef();

  useEffect(() => {
    if (!payment_id) {
      setError('Payment ID not found.');
      setLoading(false);
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Order/transiction_slip`, {
          method: 'GET',
          headers: {
            'PaymentId': payment_id,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch transaction');

        const data = await response.json();
        setTransictionDetails(Array.isArray(data) ? data : [data]);
      } catch (err) {
        setError(err.message || 'An error occurred while fetching data.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [payment_id, API_BASE_URL]);

  /* ===== PDF Download ===== */
  const downloadReceipt = async () => {
    const element = receiptRef.current;
    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save(`Payment_Receipt_${payment_id}.pdf`);
  };

  /* ===== Print ===== */
  const handlePrint = () => {
    window.print();
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen px-4">
        <img className="h-24 w-24 sm:h-32 sm:w-32 animate-spin" src={loadingSvg} alt="Loading..." />
      </div>
    );

  if (error)
    return (
      <div className="text-center text-red-500 mt-10 px-4">
        <p>{error}</p>
      </div>
    );

  if (TransictionDetails.length === 0)
    return (
      <div className="text-center text-gray-500 mt-10 px-4">
        <p>No transaction details found.</p>
      </div>
    );

  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center py-10 px-4">
      {/* Buttons (no-print) */}
      <div className="w-full max-w-lg text-right mb-3 no-print">
        <button
          onClick={downloadReceipt}
          className="bg-blue-600 text-white px-4 py-2 rounded shadow mr-2 hover:bg-blue-700 transition"
        >
          Download
        </button>
        <button
          onClick={handlePrint}
          className="bg-green-600 text-white px-4 py-2 rounded shadow hover:bg-green-700 transition"
        >
          Print
        </button>
      </div>

      {TransictionDetails.map((slip) => (
        <div
          ref={receiptRef}
          className="print-area bg-white shadow-md rounded-lg w-full max-w-lg mb-10 overflow-hidden"
          key={slip.paymentId}
        >
          {/* Header */}
          <div className="bg-[#2563eb] text-white text-center">
            <img
              src="/logo.png"
              alt="Razorpay"
              className="mx-auto w-20 h-20 sm:w-60 sm:h-60 object-contain"
            />
          </div>

          {/* Body */}
          <div className="p-4 sm:p-6 md:p-8">
            <div className="text-center mb-6">
              <div className="text-2xl sm:text-3xl font-semibold text-gray-800">
                ₹{slip.amount}
              </div>
              <div className="text-green-500 font-medium text-lg sm:text-xl">
                Paid Successfully
              </div>
            </div>

            <div className="border-t-4 border-[#2563eb] pt-4 space-y-2">
              <Info label="Payment Id" value={slip.paymentId} />
              <Info label="Track Order Id" value={slip.hemorderId} />
              <Info
                label="Paid On"
                value={format(new Date(slip.date), 'eeee, MMMM do, yyyy h:mm:ss a')}
              />
              <Info label="Method" value={slip.paymentMode} />
              <Info label="Mobile Number" value={slip.mobile || 'N/A'} />
            </div>

            <div className="border-t border-gray-200 mt-4 pt-4 space-y-2">
              <Info label="Name" value={slip.name || 'N/A'} />
              <Info label="Email" value={slip.email} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const Info = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row justify-between text-sm sm:text-base md:text-lg break-words">
    <span className="font-medium text-gray-400">{label}:</span>
    <span className="text-gray-800">{value}</span>
  </div>
);

export default PaymentReceipt;











// import React, { useEffect, useState, useRef } from 'react';
// import loadingSvg from '../../assets/bounceLoad.svg';
// import config from '../../config/config';
// import { format } from 'date-fns';
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// function PaymentReceipt() {
//   const { API_BASE_URL } = config;
//   const payment_id = sessionStorage.getItem('paymentId');

//   const [TransictionDetails, setTransictionDetails] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const receiptRef = useRef();

//   useEffect(() => {
//     if (!payment_id) {
//       setError('Payment ID not found.');
//       setLoading(false);
//       return;
//     }

//     const fetchOrderDetails = async () => {
//       try {
//         const response = await fetch(`${API_BASE_URL}/api/Order/transiction_slip`, {
//           method: 'GET',
//           headers: {
//             'PaymentId': payment_id,
//             'Content-Type': 'application/json',
//           },
//         });

//         if (!response.ok) throw new Error('Failed to fetch transaction');

//         const data = await response.json();
//         setTransictionDetails(Array.isArray(data) ? data : [data]);
//       } catch (err) {
//         setError(err.message || 'An error occurred while fetching data.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOrderDetails();
//   }, [payment_id, API_BASE_URL]);

//   /* ===== PDF Download ===== */
//   const downloadReceipt = async () => {
//     const element = receiptRef.current;
//     const canvas = await html2canvas(element, { scale: 2, useCORS: true });
//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF("p", "mm", "a4");
//     const imgWidth = 210;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//     pdf.save(`Payment_Receipt_${payment_id}.pdf`);
//   };

//   /* ===== Print ===== */
//   const handlePrint = () => {
//     window.print();
//   };

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-screen px-4">
//         <img className="h-24 w-24 sm:h-32 sm:w-32 animate-spin" src={loadingSvg} alt="Loading..." />
//       </div>
//     );

//   if (error)
//     return (
//       <div className="text-center text-red-500 mt-10 px-4">
//         <p>{error}</p>
//       </div>
//     );

//   if (TransictionDetails.length === 0)
//     return (
//       <div className="text-center text-gray-500 mt-10 px-4">
//         <p>No transaction details found.</p>
//       </div>
//     );

//   return (
//     <div className="bg-gray-100 flex flex-col items-center justify-center py-10 px-4">

//       {/* Buttons (no-print) */}
//       <div className="w-full sm:w-4/5 md:w-3/5 lg:w-2/5 text-right mb-3 no-print">
//         <button
//           onClick={downloadReceipt}
//           className="bg-blue-600 text-white px-4 py-2 rounded shadow mr-2"
//         >
//           Download
//         </button>
//         <button
//           onClick={handlePrint}
//           className="bg-green-600 text-white px-4 py-2 rounded shadow"
//         >
//           Print
//         </button>
//       </div>

//       {TransictionDetails.map((slip) => (
//         <div
//           ref={receiptRef}
//           className="print-area bg-white shadow-md rounded-lg w-full sm:w-4/5 md:w-3/5 lg:w-2/5 mb-10"
//           key={slip.paymentId}
//         >
//           {/* Header (UNCHANGED) */}
//           <div className="bg-[#2563eb] text-white text-center py-8 rounded-t-lg">
//             <img
//               src="/logo1.png"
//               alt="Razorpay"
//               className="mx-auto mb-2 w-30 h-30 sm:w-40 sm:h-40"
//             />
//           </div>

//           {/* Body */}
//           <div className="p-4 sm:p-6 md:p-8">
//             <div className="text-center mb-6">
//               <div className="text-2xl sm:text-3xl font-semibold text-gray-800">
//                 ₹{slip.amount}
//               </div>
//               <div className="text-green-500 font-medium text-lg sm:text-xl">
//                 Paid Successfully
//               </div>
//             </div>

//             <div className="border-t-4 border-[#2563eb] pt-4 space-y-2">
//               <Info label="Payment Id" value={slip.paymentId} />
//               <Info label="Track Order Id" value={slip.hemorderId} />
//               <Info
//                 label="Paid On"
//                 value={format(new Date(slip.date), 'eeee, MMMM do, yyyy h:mm:ss a')}
//               />
//               <Info label="Method" value={slip.paymentMode} />
//               <Info label="Mobile Number" value={slip.mobile || 'N/A'} />
//             </div>

//             <div className="border-t border-gray-200 mt-4 pt-4 space-y-2">
//               <Info label="Name" value={slip.name || 'N/A'} />
//               <Info label="Email" value={slip.email} />
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// const Info = ({ label, value }) => (
//   <div className="flex justify-between text-sm sm:text-lg md:text-xl">
//     <span className="font-medium text-gray-400">{label}:</span>
//     <span className="text-gray-800 break-words">{value}</span>
//   </div>
// );

// export default PaymentReceipt;
